import {
  Box, Form, SectionDivider, Text,
} from '@domain-group/suit-theme'

import usePublicationBooking from '@hooks/usePublicationBooking'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface BookingDetailsProps {
  isAdmin: boolean,
  publicationBookingPayload: ReturnType<typeof usePublicationBooking>,
  publicationFormPayload: UseFormPayload,
}

const BookingDetails = (props: BookingDetailsProps) => {
  const { isAdmin, publicationFormPayload, publicationBookingPayload } = props

  const {
    publicationBooking,
    publicationProduct,
  } = publicationBookingPayload

  const {
    entityState: {
      booking_confirmation_id,
    },
    handlers,
  } = publicationFormPayload

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>BOOKING DETAILS</SectionDivider>

      <Form boxProps={{ fontSize: 'small', marginBottom: 'large' }}>
        <>
          <Form.Row boxProps={{ alignItems: 'center' }}>
            <Text color="bodyFontLightColor">Booking Confirmation ID</Text>

            <Form.Field>
              <input
                name="booking_confirmation_id"
                value={booking_confirmation_id}
                type="text"
                disabled={!isAdmin}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Form.Row marginTop="large">
            <Text color="bodyFontLightColor">Ad Size</Text>

            <Box justifyContent="flex-end">
              {/*
               // @ts-expect-error TS2339 */}
              <Text>{publicationProduct.title}</Text>
            </Box>
          </Form.Row>

          <Form.Row marginTop="large">
            <Text color="bodyFontLightColor">Booking ID</Text>

            <Box justifyContent="flex-end">
              <Text>#{publicationBooking.id}</Text>
            </Box>
          </Form.Row>
        </>
      </Form>
    </>
  )
}

export default BookingDetails
